import { reactive } from 'vue';

export const criarAssinatura = () => {
    return reactive({
        id: 0,
        idep: 0,
        idusuario: 0,
        idsessao: 0,
        nmusuario: '',
        dhassinatura: '',
        iporigem: '',
        vsassinatura: '',
        vssistema: '',
        ass_conteudo: '',
        ass_hash: '',
        ass_senha: '',
        ass_tipoauth: '',
        doc_idorigem: 0,
        doc_tipo: '',
        acao: '',
        acao_id: 0,
        acao_obs: '',
    });
};